module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "119641.png",
      "src": "OEBPS/image/119641.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader"
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("The young couple said that they were staying at the Red Brick Inn of Augusta Bed & Breakfast to celebrate their wedding anniversary. They were pretty engaged in their own conversation. “Thanks for letting us look,” the husband said as they left. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("It made me wonder if there were any shops that charged to let folks look! Realistically, I knew it was part of doing business. You never knew when a later sale might result because of something someone had seen on a previous visit while they were just looking around.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("While it was quiet, I turned on my laptop to see what my siblings were up to. I was surprised to hear from Ellen, our newly found sister. She was now a part of our emailing group and seemed to be very comfortable joining in on the conversations.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Ellen reminded us of her invitation to come see her in Paducah during the big quilt show taking place in April. She attached a flyer advertising the event. All of us were committed except Laurie. Laurie had made it clear that it was a busy time of year for her at her shop in Fish Creek, Wisconsin. Laurie was not a quilter and didn’t have the interest that Loretta and I did. Lynn was an artist, so seeing the art quilts interested her. She had also heard about Paducah’s art district and wanted to see it. Ellen said she lived in the district. Loretta was the only one to respond to Ellen in the email, saying she wanted exact dates so she could get off work at the hospital. I responded that I would follow the lead of Lynn and Loretta’s schedule and that a vacation would be most welcomed.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Loretta then responded that her husband Bill was having some health issues related to his heart and that she was worried about him. Many years ago, he’d had a mild heart attack, but had been fine. Bill was a high school teacher and often got too involved in the students’ problems. I responded by asking her to wish him well. Loretta and Bill were both in their sixties.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Laurie joined in as I was typing. She first responded to the issue of Bill’s health and then went on to say that most of the shops in Fish Creek were opening early because the early spring was bringing such good weather. She said there weren’t typically blooms or decent weather until May in Wisconsin.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Loretta commented that they still had a little snow on the ground in Green Bay, but that the nice weather was helping it melt.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I asked about Lucy and Sarah. Nothing had been said about them lately. I knew Sarah was brokenhearted from the breakup with Lucy’s father.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Minutes later, Loretta said Sarah was looking for a better-paying job and that she was seeing the two of them more frequently on the weekends. That was good to hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I closed my laptop when a young man in a fireman’s uniform stepped into the shop. “Hello, may I help you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Hi, my name is Jim Martin. I was on my way to work and noticed you’re repairing the building that was on fire recently.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, yes. Thank you so much for your quick response. That certainly kept it from spreading to my house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You’re welcome. That’s what we’re trained to do. Lightning struck a lot of places that evening. You were lucky that someone saw it happen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I know. It was our wonderful mailman on his way to work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You’ve got a cute little shop here, and a mighty bright one, I might add,” he teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Yes, I’m the yellow house in town, and it has really grown on me. I’m easy to find!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("He grinned and nodded. “My grandmother quilted, and I have some of her quilts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That’s nice.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, I’m afraid to use them out of respect, so I just have them put away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, I’m sure she made them to be used, don’t you think?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“My girlfriend said they’re too fragile, so I don’t use them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I haven’t seen them, but are they in poor condition?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, no. They’re like new. I don’t think my grandmother ever used them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I think she would smile and approve if you used them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“You have a point there.” He blushed. “I guess I’d better be on my way. I’d like to bring my girlfriend here sometime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That would be great. Thank you again for your help with the fire.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Nice to meet you!” he said as he left.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Once again, I felt a deep sense of community in this little town where folks really cared about one another. Even the firefighter took the time to check on me. As I thought about it more, it gave me an idea for my column in ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit ")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v("magazine. I could call it “It Takes a Village.” The column could demonstrate that when a little town like Augusta has a tragedy or problem, everyone experiences it. When they have something to celebrate or plan, the whole village gets on board. That’s something that is potentially absent when one lives in a large city. A neighborhood or organization could embrace such a notion, but I knew that here in Augusta, I was blessed with a village.")]), _c('span', {
    staticClass: "byline"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d411373","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/quilt-left-behind_split7.vue
// module id = 81
// module chunks = 0